import { render, staticRenderFns } from "./PerencanaanTable.vue?vue&type=template&id=3fcd6295&scoped=true&"
import script from "./PerencanaanTable.vue?vue&type=script&lang=ts&"
export * from "./PerencanaanTable.vue?vue&type=script&lang=ts&"
import style0 from "./PerencanaanTable.vue?vue&type=style&index=0&id=3fcd6295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd6295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSimpleTable})
